export const GET_PRODUCT_ACION_TYPE = 'product/getProducts';
export const CATEGORY_TYPE = 'product.category.name';
export const CATEGORY_NAME = 'categoryName';

export const PRODUCTS_PROPS = {
  FILTERS: {
    SOURCE_PRODUCT_ID_PLACEHOLDER: 'Source Product ID',
    PRODUCT_CODE_PLACEHOLDER: 'Product Code',
    PRODUCT_NAME_PLACEHOLDER: 'Product Name',
    BARCODE_PLACEHOLDER: 'Barcode',
    STATUS_ALL: 'All',
    STATUS_ACTIVE: 'Active',
    STATUS_INACTIVE: 'Inactive',
  },
  COLUMNS: {
    OPERATOR_ID: 'Operator ID',
    PRODUCT_ID: 'Product ID',
    PRODUCT_CODE: 'Product Code',
    PRODUCT_NAME: 'Product Name',
    MARKETS: 'Markets',
    BARCODES: 'Barcodes',
    COST: 'Cost',
    PRICE: 'Price',
    STATUS: 'Status',
    UPDATED: 'Updated On',
    CREATED: 'Created On',
  },
  DIALOGS: {
    BARCODE_TITLE: 'Product Barcode Details',
    MARKET_TITLE: 'Product Market Details',
    NO_BARCODES_TITLE: 'No barcodes found',
    NO_BARCODES_DESC: 'This product has no associated barcodes.',
    NO_MARKETS_TITLE: 'No markets found',
    NO_MARKETS_DESC: 'This product has no associated markets.',
  },
};
